import { useEffect } from 'react';

import { AuthBroadCastChannel } from '#src/lib/broadcastChannel.ts';
import { reloadPage } from '#src/routing/EnsureLatestAppVersion/reloadPage.ts';

export const useSyncAuthStateAcrossTabs = () => {
  useEffect(() => {
    AuthBroadCastChannel.on(message => {
      if (message === 'logged_out') {
        reloadPage();
      }
    });
  }, []);
};
